import { FC, useRef } from 'react'
import cn from 'classnames'
import styles from 'components/atoms/inputs/DatePicker/Calendar/Calendar.styl'
import { useCalendarCell, AriaCalendarCellProps } from '@react-aria/calendar'
import { CalendarState } from '@react-stately/calendar'

type CalendarCell =
  & AriaCalendarCellProps
  & {
    isHighlighted?: boolean
    state: CalendarState
  }

export const CalendarCell: FC<CalendarCell> = (props) => {
  const { state, date, isHighlighted } = props
  const ref = useRef(null)
  const {
    cellProps,
    buttonProps,
    isSelected,
    isOutsideVisibleRange,
    isDisabled,
    isUnavailable,
    formattedDate,
  } = useCalendarCell({ date }, state, ref)

  return (
    <td { ...cellProps }>
      <div
        { ...buttonProps }
        ref={ ref }
        hidden={ isOutsideVisibleRange }
        className={ cn(styles.cell, {
          [styles.selected]: isSelected,
          [styles.disabled]: isDisabled,
          [styles.highlighted]: isHighlighted,
          [styles.unavailable]: isUnavailable,
        }) }
      >
        {formattedDate}
      </div>
    </td>
  )
}
